import $ from "jquery";

export const eventsNotificationsBtn = () => {
    const notificationsBtn = $('.header-notifications__icon-wrapper');

    notificationsBtn.click(function () {
        $(this).parent('.header-notifications').toggleClass('header-notifications--showed');
    });

    $(document).on("click", function (event) {
        if (notificationsBtn !== event.target && !notificationsBtn.has(event.target).length) {
            notificationsBtn.parent('.header-notifications').removeClass('header-notifications--showed');
        }
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            notificationsBtn.parent('.header-notifications').removeClass('header-notifications--showed');
        }
    });
};
